<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="prefix + title"
    >
      <MotivoAgregacaoList
        :prefix="prefix"
        @onDblClickMotivoAgregacaoSelect="motivoAgregacaoSelect"
      />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descMotivoAgregacao"
      :label="label"
      invalidFeedback="Motivo de Agregação deve ser informado!"
      description=""
      @handleClean="handleClean"
      :error="error"
      :cols="cols"
    >
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed>
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import MotivoAgregacaoList from "@/modules/cadastros/motivo-agregacao/MotivoAgregacaoList.vue"

export default {
  components: { LgFormInputFinder, MotivoAgregacaoList },
  props: {
    id: String,
    prefix:{
      type:String,
      default: "",
    },
    title:{
      type:String,
      default: "Motivo Agregação Item Bem Permanente",
    },

    value: Object,
    label: String,
    cols: String,
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit("input", newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit("handleClean", {});
      this.$emit("input", {});
    },
    motivoAgregacaoSelect(item) {
      this.computedValue = item;
      this.$emit("input", item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
